import SalesForceApiService from '@/api/salesforce_api_service';

export default {
  createSfOpportunity(args) {
    return new SalesForceApiService().post(`/user/salesforce/sf_opportunities`, args);
  },
};
